import cognitoApi from './cognitoAPI.js';

function OccoApi() {
  this.userListRetrieve = function (callback) {
    const body = {};
    const methodPath = '/occo-owner/user/list/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.organisationListRetrieve = function (callback) {
    const body = {};
    const methodPath = '/occo-owner/organisation/list/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  // organisationId is optional
  this.robotListRetrieve = function (organisationId, callback) {
    const body = {};
    if (organisationId) {
      body.organisation_id = organisationId;
    }
    const methodPath = '/occo-owner/robot/list/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.organisationCreate = function (organisationData, callback) {
    const body = {};
    body.name = organisationData.name;
    body.email = organisationData.email;
    body.phone = organisationData.phone;
    body.site_url = organisationData.siteUrl;
    body.address = organisationData.address;
    body.removal_ai_api_key = organisationData.removal_ai_api_key;
    body.removal_pw_api_key = organisationData.removal_pw_api_key;
    body.enable_image_process = organisationData.enableIP;
    body.webapp_domain = organisationData.webapp_domain;
    body.photo_share_domain = organisationData.photo_share_domain;
    body.mpservice_workspace_id = organisationData.mpservice_workspace_id;
    body.mpservice_ui_base_url = organisationData.mpservice_ui_base_url;
    body.mpservice_base_url = organisationData.mpservice_base_url;
    body.mpservice_api_key = organisationData.mpservice_api_key;
    body.mpservice_sso_client_id = organisationData.mpservice_sso_client_id;
    body.mpservice_sso_client_secret = organisationData.mpservice_sso_client_secret;
    const methodPath = '/occo-owner/organisation/create';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
  this.organisationUpdate = function (id, organisationData, callback) {
    const body = {};
    body.id = id;
    body.name = organisationData.name;
    body.email = organisationData.email;
    body.phone = organisationData.phone;
    body.site_url = organisationData.siteUrl;
    body.address = organisationData.address;
    body.removal_ai_api_key = organisationData.removal_ai_api_key;
    body.removal_pw_api_key = organisationData.removal_pw_api_key;
    body.enable_image_process = organisationData.enableIP;
    body.webapp_domain = organisationData.webapp_domain;
    body.photo_share_domain = organisationData.photo_share_domain;
    body.mpservice_workspace_id = organisationData.mpservice_workspace_id;
    body.mpservice_ui_base_url = organisationData.mpservice_ui_base_url;
    body.mpservice_base_url = organisationData.mpservice_base_url;
    body.mpservice_api_key = organisationData.mpservice_api_key;
    body.mpservice_sso_client_id = organisationData.mpservice_sso_client_id;
    body.mpservice_sso_client_secret = organisationData.mpservice_sso_client_secret;
    const methodPath = '/occo-owner/organisation/update';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.userCreate = function (firstName, lastName, username, email, organisationIds, roleId, callback) {
    const body = {};
    body.first_name = firstName;
    body.last_name = lastName;
    body.username = username;
    body.email = email;
    // Send both for backward compatibility
    body.organisation_ids = Array.isArray(organisationIds) ? organisationIds : [organisationIds];
    [body.organisation_id] = body.organisation_ids; // Primary org for backward compatibility
    body.role_id = roleId;
    const methodPath = '/occo-owner/user/create';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.robotCreate = function (name, organisationId, callback) {
    const body = {
      name,
      organisation_id: organisationId,
    };
    const methodPath = '/occo-owner/robot/create';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.robotUpdate = function (id, name, organisationId, callback) {
    const body = {
      id,
      name,
      organisation_id: organisationId,
    };
    const methodPath = '/occo-owner/robot/update';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.userUpdate = function (id, firstName, lastName, roleId, organisationIds, email, callback) {
    const body = {};
    body.id = id;
    body.first_name = firstName;
    body.last_name = lastName;
    body.role_id = roleId;
    // Send both for backward compatibility
    body.organisation_ids = Array.isArray(organisationIds) ? organisationIds : [organisationIds];
    [body.organisation_id] = body.organisation_ids; // Primary org for backward compatibility
    body.email = email;
    const methodPath = '/occo-owner/user/update';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.userMyInfoRetrieve = function (callback) {
    const body = {};
    const methodPath = '/occo-owner/user/my-info/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.robotSettingsRetrieve = function (robotId, callback) {
    const body = {};
    body.robot_id = robotId;
    const methodPath = '/occo-owner/robot/settings/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.userDelete = function (id, callback) {
    const body = {};
    body.id = id;
    const methodPath = '/occo-owner/user/delete';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.organisationDelete = function (id, callback) {
    const body = {};
    body.id = id;
    const methodPath = '/occo-owner/organisation/delete';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.robotDelete = function (id, callback) {
    const body = {};
    body.id = id;
    const methodPath = '/occo-owner/robot/delete';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.robotSettingsUpdate = function (robotId, state, callback) {
    const body = {};
    body.robot_id = robotId;
    body.state = state;
    const methodPath = '/occo-owner/robot/settings/update';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.eventListRetrieve = function (organisationId, callback) {
    const body = {};
    if (organisationId) {
      body.organisation_id = organisationId;
    }
    body.max_size = 5000;
    body.page_number = 1;
    const methodPath = '/occo-owner/event/list/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.assetTmpUploadAccessRetrieve = function (fileRelativePath, callback) {
    const body = {};
    body.file_relative_path = fileRelativePath;
    const methodPath = '/occo-owner/asset/tmp-upload-access/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  // Cloud Processing
  this.imageProcessCreate = function (body, callback) {
    const methodPath = '/occo-owner/image-process/create';
    const hasApiKey = true;
    const showApiErrors = true;
    occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  this.imageProcessUpdate = function (id, body, callback) {
    const updateBody = { id, ...body };
    const methodPath = '/occo-owner/image-process/update';
    const hasApiKey = true;
    const showApiErrors = true;
    occoApiPostRequestBase(hasApiKey, methodPath, updateBody, showApiErrors, callback);
  };

  this.imageProcessDelete = function (id, callback) {
    const body = { id };
    const methodPath = '/occo-owner/image-process/delete';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  this.imageProcessSummaryListRetrieve = function (callback) {
    const body = {};
    const methodPath = '/occo-owner/image-process/summary-list/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  // Retrieve single image process by id (used before editing)
  this.imageProcessRetrieve = function (id, callback) {
    const body = { id };
    const methodPath = '/occo-owner/image-process/retrieve';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };

  // MPS embedded UI SSO (Pipeline Service)
  this.mpsSsoCreate = function (body, callback) {
    const methodPath = '/occo-owner/mps/sso/create';
    const hasApiKey = true;
    const showApiErrors = true;
    occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  // MPS pipeline meta cache — batch read with lazy refresh from MPS
  // body: { uids: string (comma-separated) | string[], organisation_id?: number }
  this.mpsGetPipelineMeta = function (body, callback) {
    const methodPath = '/occo-owner/mps/pipelines/meta';
    const hasApiKey = true;
    const showApiErrors = false;
    occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  // MPS pipeline meta cache — immediate upsert after postMessage selection
  // body: { uid, title, description, updatedAt }
  this.mpsUpsertPipelineMeta = function (body, callback) {
    const methodPath = '/occo-owner/mps/pipelines/meta/upsert';
    const hasApiKey = true;
    const showApiErrors = false;
    occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  this.imagePreview = function (body, callback) {
    const methodPath = '/occo-owner/process-image-preview';
    const hasApiKey = true;
    const showApiErrors = true;
    occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  this.retrieveImagePreview = function (body, callback) {
    const methodPath = '/occo-owner/process-image-preview/retrieve';
    const hasApiKey = true;
    const showApiErrors = true;
    occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback);
  };

  this.createReport = function (type, organisationId, eventId, startDate, endDate, email, callback) {
    const body = {};
    body.type = type;
    body.start_date = startDate;
    body.end_date = endDate;
    body.organisation_id = organisationId;
    body.event_id = eventId;
    body.email = email;
    const methodPath = '/occo-owner/report/create';
    const hasApiKey = true;
    occoApiPostRequest(hasApiKey, methodPath, body, callback);
  };
}

function occoApiPostRequest(hasApiKey, methodPath, body, callback) {
  occoApiPostRequestBase(hasApiKey, methodPath, body, false, callback);
}

async function occoApiPostRequestBase(hasApiKey, methodPath, body, showApiErrors, callback) {
  const showErr = hasApiKey || showApiErrors || window.DEBUG_MODE;
  const url = `${window.BACKEND_API}${methodPath}`;

  try {
    const headers = { 'Content-Type': 'application/json' };

    if (hasApiKey) {
      headers.Authorization = await new Promise((resolve, reject) => {
        cognitoApi.getApiKey((err, key) => {
          if (err) reject(err);
          else resolve(key);
        });
      });
    }

    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });

    const resp = await response.json();

    if (resp.status === 'ok') {
      callback(null, resp.result);
    } else {
      const err = {
        type: 'occo',
        message_key: showErr ? resp.error_message_key : 'Internal Error',
        message_text: showErr ? resp.error?.message_text : 'Internal Error',
        resp,
      };
      console.error('err', JSON.stringify(err));
      callback(err, null);
    }
  } catch (error) {
    const err = {
      type: 'global',
      message_key: 'Internal Error',
      error,
    };
    console.error('err', JSON.stringify(err));
    callback(err, null);
  }
}

const occoApi = new OccoApi();
export default occoApi;
